import { useEffect } from 'react';

export const SITE_URL = 'https://garmond.ba';

function upsert(selector, create, content) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(create.tag);
    Object.entries(create.attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute(create.valueAttr, content);
}

// Postavlja title, opis, canonical i Open Graph oznake za trenutnu stranicu.
export default function usePageMeta({ title, description, path }) {
  useEffect(() => {
    if (!title) return;
    // Prerenderirane stranice su direktoriji (…/index.html), pa je kanonska adresa s kosom crtom na kraju.
    const url = `${SITE_URL}${path === '/' ? '/' : `${path.replace(/\/$/, '')}/`}`;
    document.title = title;
    if (description) {
      upsert('meta[name="description"]', { tag: 'meta', attrs: { name: 'description' }, valueAttr: 'content' }, description);
      upsert('meta[property="og:description"]', { tag: 'meta', attrs: { property: 'og:description' }, valueAttr: 'content' }, description);
      upsert('meta[name="twitter:description"]', { tag: 'meta', attrs: { name: 'twitter:description' }, valueAttr: 'content' }, description);
    }
    upsert('link[rel="canonical"]', { tag: 'link', attrs: { rel: 'canonical' }, valueAttr: 'href' }, url);
    upsert('meta[property="og:url"]', { tag: 'meta', attrs: { property: 'og:url' }, valueAttr: 'content' }, url);
    upsert('meta[property="og:title"]', { tag: 'meta', attrs: { property: 'og:title' }, valueAttr: 'content' }, title);
    upsert('meta[name="twitter:title"]', { tag: 'meta', attrs: { name: 'twitter:title' }, valueAttr: 'content' }, title);
  }, [title, description, path]);
}
